import React from 'react';
import styled from 'styled-components';
import { DestinationRating } from '@hotelplan/components.common.destination-attributes';
import { Icon } from '@hotelplan/components.common.icon';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { mapAttributeNameToIcon } from './PdpDestinationAttributes.mappers';

interface IPdpDestinationAttributesProps {
  attributes: {
    id: string;
    name?: string;
    rating: number;
  }[];
}

const Wrapper = styled.div(
  sx2CssThemeFn(({ theme: { media } }) => ({
    [media.mobile]: {
      display: 'flex',
      justifyContent: 'center',
    },
  }))
);

const List = styled.div.attrs({
  className: 'attributes-list',
})(
  sx2CssThemeFn({
    display: ['inline-block', 'flex'],
    flexWrap: [null, 'wrap'],
  })
);

const DestinationAttribute = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    mb: [3, 5],
    mr: [null, 7],

    '.attribute-icon': {
      mr: 3,
    },

    span: {
      fontSize: ['14px', '15px'],
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
  })
);

const PdpDestinationAttributes: React.FC<IPdpDestinationAttributesProps> = ({
  attributes,
}: IPdpDestinationAttributesProps) => {
  return (
    <Wrapper>
      <List>
        {attributes.map(attribute => {
          return (
            <DestinationAttribute key={attribute.id}>
              {/*todo: make icon work*/}
              <Icon
                className="attribute-icon"
                size="xxlg"
                name={mapAttributeNameToIcon(attribute.id)}
              />
              <div>
                <span>{attribute.name}</span>
                <DestinationRating rating={attribute.rating} />
              </div>
            </DestinationAttribute>
          );
        })}
      </List>
    </Wrapper>
  );
};

export default PdpDestinationAttributes;
